import type { ReactNode } from 'react';

/** Props de uma página de status (404, 403, erro). */
export interface StatusPageProps {
  title: string;
  description: string;
  traceId?: string | undefined;
  children?: ReactNode;
}

/**
 * Conteúdo de status com título como foco principal. É uma `section`: dentro do layout ela
 * fica no `main` dele; fora, envolva com `StandalonePage`.
 */
export function StatusPage({ title, description, traceId, children }: StatusPageProps): ReactNode {
  return (
    <section className="mx-auto flex min-h-[60vh] max-w-lg flex-col justify-center gap-4 p-6">
      <h1 className="text-2xl font-semibold">{title}</h1>
      <p className="text-muted-foreground">{description}</p>
      {traceId !== undefined && (
        <p className="text-sm text-muted-foreground">
          Código de rastreio: <code>{traceId}</code>
        </p>
      )}
      {children}
    </section>
  );
}
